import { ICellRendererParams } from 'ag-grid-community';
import { t } from 'i18next';

import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { TextLine } from 'core/elements';
import { getAgGridTableCellData, getTranslationKey } from 'core/utils';
import { QuotePartColId } from 'quotes/components/QuotePartList';

const InventoryStatusCell = (props: ICellRendererParams) => {
  const data = getAgGridTableCellData(props, QuotePartColId.INVENTORY_STATUS);
  if (!data) {
    return props?.value;
  }

  const { inventoryStatus } = data;

  const text = inventoryStatus?.status
    ? t(getTranslationKey('labelInventoryStatus', inventoryStatus?.status))
    : DEFAULT_PLACEHOLDER;

  return <TextLine text={text} />;
};

export default InventoryStatusCell;
